import CryptoJS from 'crypto-js'

// 加密密钥（根据接口文档）
const VITE_CIPHER_KEY = 'EY8WePvjM5GGwQzn'

/**
 * 密码加密流程（按照接口文档要求）
 * 1. 一次MD5加密
 * 2. AES加密（使用MD5(密钥)作为AES密钥）
 * 3. 将Base64结果转换为Hex格式
 * @param {string} password 明文密码
 * @returns {string} 加密后的密码（Hex格式）
 */
export function encryptPassword(password) {
  try {
    // console.group('🔐 密码加密流程')

    // 1. 一次MD5加密
    const md5Str = CryptoJS.MD5(password).toString()
    // console.log('1. MD5加密结果:', md5Str)
    // console.log('   MD5长度:', md5Str.length)

    // 验证MD5：123456 -> e10adc3949ba59abbe56e057f20f883e
    if (password === '123456') {
      // console.log('   ✓ MD5验证通过: e10adc3949ba59abbe56e057f20f883e')
    }

    // 2. 使用MD5(VITE_CIPHER_KEY)作为AES密钥
    const aesKey = CryptoJS.MD5(VITE_CIPHER_KEY).toString()
    // console.log('2. AES密钥(MD5(VITE_CIPHER_KEY)):', aesKey)
    // console.log('   密钥长度:', aesKey.length)

    // 3. AES加密（ECB模式，PKCS7填充）
    const keyHex = CryptoJS.enc.Utf8.parse(aesKey)
    const encrypted = CryptoJS.AES.encrypt(md5Str, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })

    const base64Result = encrypted.toString()
    // console.log('3. AES加密结果(Base64):', base64Result)
    // console.log('   Base64长度:', base64Result.length)

    // 4. 将Base64转换为Hex格式
    const base64Parsed = CryptoJS.enc.Base64.parse(base64Result)
    const hexResult = CryptoJS.enc.Hex.stringify(base64Parsed)
    // console.log('4. 转换为Hex格式:', hexResult)
    // console.log('   Hex长度:', hexResult.length)

    // 验证结果
    const expected = 'd4958348e22108119b3ef57b022c83f4bf857dd0b247eaab15b9a43d47ee3c503900f7135bf0de255bc33620c3cdc02b'
    if (password === '123456' && hexResult === expected) {
      // console.log('✅ 加密结果验证通过！')
    } else if (password === '123456') {
      // console.log('❌ 加密结果不匹配！')
      // console.log('   预期:', expected)
      // console.log('   实际:', hexResult)
    }

    // console.groupEnd()
    return hexResult
  } catch (error) {
    // console.error('密码加密失败:', error)
    throw new Error('密码加密失败: ' + error.message)
  }
}

/**
 * 更简洁的加密函数（直接使用接口文档示例方法）
 */
export function encryptPasswordSimple(password) {
  // 1. MD5加密
  const md5Str = CryptoJS.MD5(password).toString()

  // 2. 使用MD5(VITE_CIPHER_KEY)作为AES密钥
  const aesKey = CryptoJS.MD5(VITE_CIPHER_KEY).toString()

  // 3. AES加密
  const encrypted = CryptoJS.AES.encrypt(
    md5Str,
    CryptoJS.enc.Utf8.parse(aesKey),
    {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    }
  )

  // 4. 转换为Hex格式
  return CryptoJS.enc.Hex.stringify(CryptoJS.enc.Base64.parse(encrypted.toString()))
}

/**
 * 测试加密函数
 */
export function testEncryption(password = '123456') {
  // console.group('🧪 加密测试')

  // console.log('测试密码:', password)

  // 测试主要方法
  const result1 = encryptPassword(password)
  // console.log('方法1结果:', result1)

  // 测试简化方法
  const result2 = encryptPasswordSimple(password)
  // console.log('方法2结果:', result2)

  // 验证预期结果
  const expected = 'd4958348e22108119b3ef57b022c83f4bf857dd0b247eaab15b9a43d47ee3c503900f7135bf0de255bc33620c3cdc02b'

  if (password === '123456') {
    // console.log('预期结果:', expected)
    // console.log('方法1匹配:', result1 === expected)
    // console.log('方法2匹配:', result2 === expected)
    // console.log('两种方法一致:', result1 === result2)
  }

  // console.groupEnd()

  return {
    method1: result1,
    method2: result2,
    expected: expected,
    matches: result1 === expected && result2 === expected
  }
}

// 其他函数保持不变...
export function getCaptchaUrl(length = 4, timestamp = Date.now().toString()) {
  return `/api/OAuth/ImageCode/${length}/${timestamp}`
}

/**
 * 存储Token - 适配新的token数据结构
 * @param {Object} tokenData Token数据
 */

export function storeToken(tokenData) {
  const { token, expires_in, token_type, userId, tenantId, theme, isSaas } = tokenData

  // console.log('开始存储Token，接收到的数据:', {
  //   token: token ? token.substring(0, 20) + '...' : null,
  //   expires_in,
  //   token_type,
  //   userId,
  //   tenantId
  // })

  // 移除"Bearer "前缀，存储纯token
  const accessToken = token ? token.replace('Bearer ', '') : tokenData.accessToken

  // 计算过期时间
  const expiresIn = expires_in || 24 * 60 * 60
  const expiryTime = Date.now() + expires_in * 1000

  localStorage.setItem('accessToken', accessToken)
  localStorage.setItem('expiresIn', expiryTime.toString())
  localStorage.setItem('tokenType', token_type || 'Bearer')
  localStorage.setItem('userId', userId || '')
  localStorage.setItem('tenantId', tenantId || 'default')

  // 存储额外的主题信息
  if (theme) {
    localStorage.setItem('theme', theme)
  }

  if (isSaas !== undefined) {
    localStorage.setItem('isSaas', JSON.stringify(isSaas))
  }

  // console.log('Token已存储到localStorage:', {
  //   accessToken: accessToken.substring(0, 20) + '...',
  //   expiresIn: new Date(expiryTime).toLocaleString(),
  //   userId,
  //   tenantId
  // })
}


export function checkTokenExpiration() {
  const expiresIn = localStorage.getItem('expiresIn')
  if (!expiresIn) return true

  const now = Date.now()
  const expiresTime = parseInt(expiresIn)

  // 如果Token即将在5分钟内过期，提示刷新
  if (expiresTime - now < 5 * 60 * 1000) {
    console.warn('Token即将过期，建议刷新')
    return true
  }

  return now > expiresTime
}

export function clearToken() {
  localStorage.removeItem('accessToken')
  localStorage.removeItem('expiresIn')
  localStorage.removeItem('tokenType')
  localStorage.removeItem('userId')
  localStorage.removeItem('tenantId')
}

export function getToken() {
  const accessToken = localStorage.getItem('accessToken')
  const expiresIn = localStorage.getItem('expiresIn')
  const tokenType = localStorage.getItem('tokenType')
  const userId = localStorage.getItem('userId')
  const tenantId = localStorage.getItem('tenantId')

  return {
    accessToken,
    expiresIn,
    tokenType,
    userId,
    tenantId,
    isExpired: checkTokenExpiration()
  }
}

export function validatePhone(phone) {
  const phoneRegex = /^1[3-9]\d{9}$/
  return phoneRegex.test(phone)
}

export function validateEmail(email) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

// 导出默认对象
export default {
  encryptPassword,
  encryptPasswordSimple,
  testEncryption,
  getCaptchaUrl,
  storeToken,
  clearToken,
  getToken,
  checkTokenExpiration,
  validatePhone,
  validateEmail
}
